import React, {useRef, useEffect} from 'react';
import { XText } from "./XText"
import {useNodes} from './NodeContext'

import {FaLink} from 'react-icons/fa';
// import { formToJSON } from "axios";
import {smoothScrollTo} from "../utils/"


export interface MyComponentProps {
  // Define your prop types here
   nodes: []
   number?: number
   id: string
}

export const XDiv: React.FC<MyComponentProps> = (props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const {info, handleChangeInfo} = useNodes();
  const isFocus = info.resourceid.includes(props.id) ? true : false
  const style = isFocus ? {"backgroundColor": "yellow"} : {}


  const scrollToElement = () => {
    if (divRef.current) {
      //divRef.current.scrollIntoView({  behavior: 'smooth' });
      smoothScrollTo(divRef.current, 1000); // 1000ms = 1 second
    }
  };

  useEffect(() => {
    if (isFocus) {
      scrollToElement();
    }
  }, [isFocus]);

  return (
    <div ref={divRef} style={style} id={props.id}>
       <h1 className="lbp-text-heading"><span className="lbp-span-link lbp-header-link" onClick={() => {handleChangeInfo("http://scta.info/resource/" + props.id + info.focusInfo.mtFocus)}}><FaLink/></span> <XText nodes={props.nodes}/></h1>
    </div>
  )
}